import { render, staticRenderFns } from "./WhatsAppGroupAdd.vue?vue&type=template&id=3caa020c"
import script from "./WhatsAppGroupAdd.vue?vue&type=script&lang=js"
export * from "./WhatsAppGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports